import { render, staticRenderFns } from "./reviewer-endorsement-preview-form.component.vue?vue&type=template&id=3ee6d9fb"
import script from "./reviewer-endorsement-preview-form.component.ts?vue&type=script&lang=ts&external"
export * from "./reviewer-endorsement-preview-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./reviewer-endorsement-preview-form.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports